import { useState } from "react";

export interface BackgroundHook {
  fixedPage: boolean;
  setFixedPage: () => void;
  setDynamicPage: () => void;
}

export const useBackground = (initialState: boolean): BackgroundHook => {
  const [state, setState] = useState({ fixedPage: initialState });
  
  return {
    ...state,
    setFixedPage: () => {
      if (!state.fixedPage) {
        setState({ fixedPage: true });
      }
    },
    setDynamicPage: () => {
      if (state.fixedPage) {
        setState({ fixedPage: false });
      }
    },
  };
};
